export default "__VITE_ASSET__d4e88e9f__"